<template>
  <div class="home-foot">
    <div class="foot-top">
      <div class="txt">
        丈量，不可估量的未来<br />
        赛码，致力成为在线考试专业平台
      </div>
      <div class="bottom-btns">
        <a @click="goTest" class="btn-blue-hover">试用</a
        ><a @click="chatShow">咨询顾问</a>
      </div>
    </div>
    <us-pc-dialog
      :dialogVisible="isPcDialogShow"
      @cancel="isPcDialogShow = false"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
      isPcDialogShow: false,
    }
  },
  created() {
    this.isMobile = this.$store.state.app.device
  },
  methods: {
    goTest() {
      if (this.isMobile) {
        this.isPcDialogShow = true
      } else {
        this.$bus.emit('compRegisterChoose')
      }
    },
    chatShow() {
      this.$bus.emit('chatShow')
    },
  },
}
</script>

<style lang="scss" scoped>
.home-foot {
  padding: 0px;
  background: #fff;
  max-height: 280px;
  .foot-top {
    background: url('~@/static/images/foot-top.png');
    background-size: cover;
    height: 280px;
    padding: 40px 0px 0px;
    text-align: center;
    width: 100%;

    .txt {
      display: block;
      font-size: 28px;
      font-weight: 300;
      line-height: 60px;
      color: #fff;
    }
    .bottom-btns {
      padding: 30px 0px 0px;
      a {
        font-size: 14px;
        padding: 6px 30px;
        cursor: pointer;
        color: #fff;
        border: 2px solid #fff;
        border-radius: 2px;
        margin-right: 20px;
        &:hover {
          border: 2px solid #29bdb9;
          background: #29bdb9;
          color: #fff;
        }
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .home-foot {
    height: 280px;
    .foot-top {
      height: 280px;
      .txt {
        font-size: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/footer.vue